import axios from 'axios';
import KeycloakService from './keycloak';

const getAxiosClient = () => {
    const kc = KeycloakService.getInstance;
    const isAuthRequired = true;

    const getBaseUrl = () => {
        const host = window.location.hostname;
        if (host.includes('localhost')) return 'http://localhost:8080';

        return `https://${host}`;
    };

    const client = axios.create({
        baseURL: getBaseUrl(),
        responseType: 'json',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    client.interceptors.request.use(async (config) => {
        if (isAuthRequired) {
            if (kc.isTokenExpired()) {
                try {
                    await kc.updateToken();
                } catch (e) {
                    kc.logout();
                }
            }

            config.headers.Authorization = `Bearer ${kc.token}`;
        }

        return config;
    });

    client.interceptors.response.use(
        (response) => {
            if (response.headers['content-type'] && response.headers['content-type'].includes('text/html')) {
                // eslint-disable-next-line prefer-promise-reject-errors
                return Promise.reject({ response: { data: 'HTML returned from web server' } });
            }
            return response;
        },
        (error) => {
            if (error?.response?.status === 401) {
                kc.logout();
            }
            if (error?.response?.data) {
                // eslint-disable-next-line no-console
                console.error(error.response.data);
            }
            return Promise.reject(error);
        },
    );

    return client;
};

export default getAxiosClient;
